<div class="flex-row">
    <div class="flex-1"></div>

    <div class="flex-3 scrollable-table"></div>

    <div class="flex-1"></div>
</div>
